import { useEffect, useRef, useState } from 'react';

/**
 * Animates from 0 to `end` over duration when start=true.
 */
export default function useCountUp({ end, duration = 1500, start = false, decimals = 0 }) {
  const [value, setValue] = useState(0);
  const rafRef = useRef(null);

  useEffect(() => {
    if (!start) return;
    let startTs = null;
    const step = (ts) => {
      if (!startTs) startTs = ts;
      const progress = Math.min((ts - startTs) / duration, 1);
      // easeOutCubic
      const eased = 1 - Math.pow(1 - progress, 3);
      setValue(end * eased);
      if (progress < 1) rafRef.current = requestAnimationFrame(step);
    };
    rafRef.current = requestAnimationFrame(step);
    return () => rafRef.current && cancelAnimationFrame(rafRef.current);
  }, [end, duration, start]);

  return decimals > 0 ? value.toFixed(decimals) : Math.round(value);
}
